import React from 'react';
import styles from './PageContent.module.css';

export const AssessmentPageContent: React.FC = ({ children }) => {
  return <div className={styles.PageContent}>{children}</div>;
};
